import apiClient from "../../client/apiClient";
export type SectionInfo = {
  _id: string;
  name: string;
  class?: {
    _id: string;
    name: string;
  };
};
export type Room = {
  _id: string;
  name: string;
  capacity: number;
  floor?: string;
  type: "classroom" | "lab" | "hall" | "office" | "other";
  branch: string;
  system: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
};
export type Section = {
  _id: string;
  name: string;
  class?: {
    _id: string;
    name: string;
  };
  room?: string;
  roomAssignmentId?: string;
};
export type AssignedRoom = {
  _id?: string;
  assignmentId?: string; 
  assignedId?: string;
  class?: {
    _id: string;
    name: string;
  } | string; 
  room?: Room | string | null; 
  name?: string;
  floor?: string;
  type?: string;
  capacity?: number;
  section: SectionInfo;
  classSection?: {
    classId: string;
    className: string;
    sectionId: string;
    sectionName: string;
  };
  isActive: boolean;
  assignedBy?: {
    _id: string;
    name: string;
    email: string;
  };
  assignedAt: string;
  updatedBy?: {
    _id: string;
    name: string;
    email: string;
  };
  updatedAt?: string;
};

export type FetchRoomsResponse = {
  data: Room[];
  assignedRooms: AssignedRoom[];
  pagination: {
    total: number;
    totalPages: number;
    currentPage: number;
    limit: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
  success: boolean;
  message: string;
};

export type AssignedRoomsResponse = {
  success: boolean;
  message: string;
  data: AssignedRoom[];
  assignedRooms: AssignedRoom[];
  pagination: {
    total: number;
    totalPages: number;
    currentPage: number;
    limit: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
};

export type SectionsResponse = {
  success: boolean;
  sections: Section[];
  pagination?: {
    total: number;
    totalPages: number;
    currentPage: number;
    limit: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
};

export const fetchAvailableRooms = async (): Promise<Room[]> => {
  const response = await apiClient({
    url: "/room-assign/available",
    method: "GET",
  });
  return response.data.data;
};

export const getAssignedRooms = async (params?: {
  page?: number;
  limit?: number;
  searchText?: string;
  type?: string;
  floor?: string;
  section?: string;
  capacity?: number;
  sortBy?: string;
  sortOrder?: string;
  status?: string;
    class?: string
}): Promise<AssignedRoomsResponse> => {
  const response = await apiClient({
    url: "/room-assign",
    method: "GET",
    params,
  });
  return response.data;
};

export const assignRoom = async (classId: string, sectionId: string, roomId: string): Promise<AssignedRoom> => {
  const response = await apiClient({
    url: "/room-assign",
    method: "POST",
    data: { section: sectionId, room: roomId , class: classId,},
  });
  return response.data.data;
};

export const updateRoomAssignment = async (assignmentId: string, roomId: string): Promise<AssignedRoom> => {
  const response = await apiClient({
    url: `/room-assign/${assignmentId}`,
    method: "PUT",
    data: { room: roomId },
  });
  return response.data.data;
};

export const deleteRoomAssignment = async (assignmentId: string): Promise<AssignedRoom> => {
  const response = await apiClient({
    url: `/room-assign/${assignmentId}`,
    method: "DELETE",
  });
  return response.data.data;
};

export const fetchSections = async (params?: {
  page?: number;
  limit?: number;
  searchText?: string;
  class?: string;
  branch?: string;
  system?: string;
  sortBy?: string;
  sortOrder?: string;
}): Promise<SectionsResponse> => {
  const response = await apiClient({
    url: "/sections",
    method: "GET",
    params,
  });
  return response.data;
};

export const getSectionById = async (id: string): Promise<Section> => {
  const response = await apiClient({
    url: `/sections/${id}`,
    method: "GET",
  });
  return response.data;
};

export const RoomService = {
  assignRoom,
  updateRoomAssignment,
  deleteRoomAssignment,
  fetchAvailableRooms,
  getAssignedRooms,
  fetchSections,
  getSectionById,
};

export default RoomService;